import type { Editor } from '@tiptap/react';
import { JSXElementConstructor } from 'react';
import {
  ChatMessageListItem,
  IChatConversation,
  IChatMessage,
} from 'src/@types/chat';
import { Doc } from 'src/@types/docs';
import { IDriveContent } from 'src/@types/drive';
import { TodoItem, TodoList } from 'src/requests/todos';

export type ExtendedSearchResult = {
  type: string;
  searchType?: string;
  name: string;
};

export enum SortByEnum {
  LAST_UPDATED = 'lastUpdated',
  LAST_CREATED = 'lastCreated',
}

export enum SearchTypeEnum {
  CHAT = 'chat',
  TODOS = 'todos',
  DOCS = 'docs',
  DRIVE = 'drive',
  BOARD = 'board',
  MEMBERS = 'members',
}

export enum SearchResultType {
  all = 'all',
  channels = 'channels',
  todos = 'todos',
  docs = 'docs',
  drive = 'drive',
}

export type SearchResultItem = (
  | IChatConversation
  | IChatMessage
  | TodoItem
  | TodoList
  | Doc
  | IDriveContent
) &
  ExtendedSearchResult;

export type MappedSearchResult = {
  [SearchResultType.all]: SearchResultItem[];
  [SearchResultType.channels]?: (IChatConversation & ExtendedSearchResult)[];
  [SearchResultType.todos]?: ((TodoItem | TodoList) & ExtendedSearchResult)[];
  [SearchResultType.docs]?: (Doc & ExtendedSearchResult)[];
  [SearchResultType.drive]?: (IDriveContent & ExtendedSearchResult)[];
};

export enum TodosType {
  TODO = 'todo',
  TODO_ITEM = 'todoItem',
}

export type RowProps<Row> = {
  onClick: () => void;
  row: Row;
  editor: Editor;
};

export type RowDefinitions = {
  text: JSXElementConstructor<RowProps<IChatConversation>>;
  voice: JSXElementConstructor<RowProps<IChatConversation>>;
  meeting: JSXElementConstructor<RowProps<IChatConversation>>;
  channelMessage: JSXElementConstructor<RowProps<ChatMessageListItem>>;
  todo: JSXElementConstructor<RowProps<TodoList>>;
  todoItem: JSXElementConstructor<RowProps<TodoItem>>;
  doc: JSXElementConstructor<RowProps<Doc>>;
  driveContent: JSXElementConstructor<RowProps<IDriveContent>>;
};
